import { Component, inject, Input, OnInit } from '@angular/core';
import {
  IonButton,
  IonContent,
  ModalController,
} from '@ionic/angular/standalone';
import {
  DeviceActionStackService,
  EdroNetworkManager,
} from '../../../../../manager/edro-network-manager';
import { Pool, PoolAdditionalData } from '../../../../../../../apis/pool.api';
import { IProduct } from '../../../../IProduct';
import { HeaderConfigurationComponent } from '../../../../../../../components/ecosystems/header-configuration/header-configuration.component';
import { TranslatePipe } from '@ngx-translate/core';
import { P00039DataRxTxIndex } from '../../../P00039Sync';
import { LabelConfigurationComponent } from '../../../../../../../components/ecosystems/label-configuration/label-configuration.component';
import { LabelDescriptionComponent } from '../../../../../../../components/ecosystems/label-description/label-description.component';
import { LargedLinkComponent } from '../../../../../../../components/ecosystems/larged-link/larged-link.component';
import { P0003607PositionTypeEnum } from '../../Enum/P0003607PositionTypeEnum';
import { P0003607DureeInversion } from '../../Enum/P0003607DureeInversion';
import { P0003607AsservissementVolet } from '../../Enum/P0003607AsservissementVolet';
import { P0003607SensContactSelEnum } from '../../Enum/P0003607SensContactSelEnum';
import { P0003607ESPPolariteComponent } from '../../Electrolyseur/EnSavoirPlus/p0003607-esppolarite/p0003607-esppolarite.component';
import { TwoChoicesModalComponent } from '../../../../../../../components/ecosystems/two-choices-modal/two-choices-modal.component';
import { SlideModalController } from '../../../../../../slide-modal.service';
import { FunctionEnSavoirPlusModalComponent } from '../../../../../../../components/ecosystems/function-en-savoir-plus-modal/function-en-savoir-plus-modal.component';

@Component({
  selector: 'app-p0003607-installation-volet',
  templateUrl: './p0003607-installation-volet.component.html',
  styleUrls: ['./p0003607-installation-volet.component.scss'],
  standalone: true,
  imports: [
    HeaderConfigurationComponent,
    IonButton,
    IonContent,
    TranslatePipe,
    LabelConfigurationComponent,
    LabelDescriptionComponent,
    LargedLinkComponent,
  ],
})
export class P0003607InstallationVoletComponent implements OnInit {
  private slideModalController: SlideModalController =
    inject(SlideModalController);
  private modalController: ModalController = inject(ModalController);
  private edroNetworkManager: EdroNetworkManager = inject(EdroNetworkManager);
  @Input() prev: () => void = () => {};
  @Input() next: (
    actionStack: DeviceActionStackService,
    poolAdditionalData: PoolAdditionalData,
  ) => void = () => {};

  @Input() productClass: IProduct | null = null;

  @Input() pool: Pool | null = null;

  @Input() poolAdditionalData: PoolAdditionalData | null = null;

  @Input() actionStackParam: any | null = null;
  actionStack: DeviceActionStackService | null = null;

  constructor() {
    this.EnSavoirPlusModal = this.EnSavoirPlusModal.bind(this);
  }

  ngOnInit() {
    this.actionStack = new DeviceActionStackService(
      this.productClass!,
      this.edroNetworkManager,
      this.actionStackParam,
    );
  }

  async EnSavoirPlusModal() {
    const modal = await this.slideModalController.create({
      component: FunctionEnSavoirPlusModalComponent,
      componentProps: {
        description: 'P0003607.installation.desinfection.ESP',
      },
      config: {
        position: 'right',
        size: 'medium',
        showBackdrop: true,
        backdropDismiss: true,
      },
      animationConfig: {
        duration: 300,
        easing: 'ease-out',
      },
    });

    await modal.present();
  }

  async openModal() {
    const modal = await this.modalController.create({
      component: TwoChoicesModalComponent,
      componentProps: {
        title: 'P0003607.modal.senscontactsel.title',
        value: this.actionStack!.getValue('esISensContactSel'),
        firstChoice: {
          title: 'P0003607.modal.senscontactsel.option0',
          image:
            '/assets/ecosystem/images/products/P0003607/P0003607-senscontact-0.png',
          value: 0,
        },
        secondChoice: {
          title: 'P0003607.modal.senscontactsel.option1',
          image:
            '/assets/ecosystem/images/products/P0003607/P0003607-senscontact-1.png',
          value: 1,
        },
      },
      cssClass: 'dynamic-height',
    });

    await modal.present();

    const { data } = await modal.onDidDismiss();
    if (data) {
      this.actionStack!.editValue(
        P00039DataRxTxIndex.ElectrolyseurStandard_Installation,
        'esISensContactSel',
        data.value,
        null,
      );
    }
  }

  onSubmit() {
    this.next(this.actionStack!, this.poolAdditionalData!);
  }

  protected readonly P00039DataRxTxIndex = P00039DataRxTxIndex;
  protected readonly P0003607AsservissementVolet = P0003607AsservissementVolet;
  protected readonly P0003607SensContactSelEnum = P0003607SensContactSelEnum;
}
